<template>
  <v-dialog max-width="440px" v-model="showDialog" persistent>
    <v-card>
      <v-card-title class="secondary white--text py-3 px-5">
        <span class="text-subtitle-1 font-weight-bold">Add Containers</span>
        <v-spacer />
        <v-btn icon color="white" small @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-5 pt-4">
        <div class="caption grey--text mb-3" v-if="location">
          Adding to <strong>{{ location.location_name }}</strong>
        </div>
        <v-row dense>
          <v-col cols="12">
            <MultiSelect
              label="Container Type *"
              :items="containerTypeList"
              itemText="type_name"
              itemValue="id"
              outlined
              dense
              clearable
              hide-details="auto"
              v-model="form.container_type"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              label="Additional Qty *"
              type="number"
              min="1"
              outlined
              dense
              hide-details="auto"
              v-model="form.qty"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="mt-3" />

      <v-card-actions class="px-5 py-3">
        <v-spacer />
        <v-btn depressed outlined @click="closeDialog" class="mr-2">Cancel</v-btn>
        <v-btn
          color="primary"
          depressed
          :loading="submitting"
          :disabled="!isFormValid"
          @click="submit"
        >
          Add
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";

export default {
  name: "AddContainersDialog",
  components: { MultiSelect },
  props: {
    value: { type: Boolean, default: false },
    location: { type: Object, default: null },
  },
  watch: {
    value(val) {
      if (val) {
        this.resetForm();
        this.fetchInitialData();
      }
    },
  },
  data() {
    return {
      form: { container_type: null, qty: null },
      containerTypeList: [],
      submitting: false,
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    isFormValid() {
      return !!this.form.container_type && this.form.qty > 0;
    },
  },
  methods: {
    resetForm() {
      this.form = { container_type: null, qty: null };
    },
    closeDialog() {
      this.showDialog = false;
    },
    fetchInitialData() {
      this.$api.containerType.getContainerTypeList({ limit: "all" }).then((res) => {
        this.containerTypeList = res.data;
      });
    },
    submit() {
      if (!this.location) return;
      this.submitting = true;
      const getVal = (v) => (v && typeof v === "object" ? v.id : v);
      const payload = {
        container_type: getVal(this.form.container_type),
        qty: this.form.qty,
      };
      this.$api.workload
        .addContainersToWorkload(this.location.workload_id, payload)
        .then(() => {
          this.$bus.$emit("showToastMessage", {
            message: "Containers added successfully!",
            color: "success",
          });
          this.$emit("containersAdded");
          this.closeDialog();
        })
        .catch((err) => {
          this.$bus.$emit("showToastMessage", {
            message:
              err?.data?.detail || err?.data?.error || err?.message || "Failed to add containers.",
            color: "error",
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
